/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleTransactionTypes from './transaction-types/moduleTransactionType.js'
import modulePropertyTypes from './property-types/modulePropertyType.js'
import moduleWorker from './workers/moduleWorker.js'
import moduleCustomer from './customers/moduleCustomer.js'
import moduleTransaction from './transactions/moduleTransaction.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'


export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        // todo: moduleTodo,
        // calendar: moduleCalendar,
        // chat: moduleChat,
        // email: moduleEmail,
        auth: moduleAuth,
        transactions: moduleTransaction,
        workers: moduleWorker,
        customers: moduleCustomer,
        propertyTypes: modulePropertyTypes,
        transactionTypes: moduleTransactionTypes,
        eCommerce: moduleECommerce,
    },
    strict: process.env.NODE_ENV !== 'production'
})